module.exports = __webpack_public_path__ + "img/news_background.e029fe49.svg";